import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isPlatformAdmin } from "../../constants/roles";
import "./InventoryPage.css";

const InventoryPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const token = useMemo(() => sessionStorage.getItem("auth_token"), []);

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch("/api/inventory/assets", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || "Failed to load inventory");

        setItems(data.items || []);
      } catch (e) {
        setError(e.message || "Failed to load inventory");
      } finally {
        setLoading(false);
      }
    };

    if (token) load();
  }, [token]);


useEffect(() => {
  if (user && !isPlatformAdmin(user.role)) navigate("/");
}, [user, navigate]);


  return (
    <div className="inv-page">
      <div className="inv-card">
        <div className="inv-header">
          <div>
            <h1 className="inv-title">Asset Inventory</h1>
            <p className="inv-subtitle">
              Manage assets that are used to map CVEs to impacted devices.
            </p>
          </div>

          <div className="inv-actions">
            <button className="inv-btn" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>
        </div>

        {loading ? (
          <div className="inv-msg">Loading inventory...</div>
        ) : error ? (
          <div className="inv-error">{error}</div>
        ) : items.length === 0 ? (
          <div className="inv-msg">No assets found.</div>
        ) : (
          <div className="inv-table-wrap">
            <table className="inv-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Hostname</th>
                  <th>IP</th>
                  <th>Env</th>
                  <th>OS</th>
                  <th>App</th>
                  <th>Version</th>
                  <th>Criticality</th>
                  <th>Owner</th>
                </tr>
              </thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id}>
                    <td>{a.name || "-"}</td>
                    <td>{a.hostname || "-"}</td>
                    <td>{a.ip_address || "-"}</td>
                    <td>{a.environment || "-"}</td>
                    <td>{a.os_type || "-"}</td>
                    <td>{a.application_name || "-"}</td>
                    <td>{a.application_version || "-"}</td>
                    <td>{a.business_criticality || "-"}</td>
                    <td>{a.owner || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryPage;
